<template>
    <div class="about-us">
        <menuBox :step="3"></menuBox>
        <div class="banner">
            Hubungi kami
        </div>
        <div class="about-box">
            <div class="us">
                
                <div>
                    <p class="top-1">Alamat</p>
                    <div>Jl Jend Ahmad Yani Kuala Kampuas Kel Selat Hilir Kec Selat Kab Kapuas</div>
                </div>
            </div>
            <div class="input-box">
                <input type="text" name="fname" placeholder="Nama" class="input-text">
                <input type="text" name="fname" placeholder="Surat" class="input-text">
                <textarea type="text" name="fname" placeholder="Pesan" rows="5" class="input-message"></textarea>
                <div class="btn">Kirim</div>
            </div>
        </div>

        <footerBox></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'App',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style lang="less" scoped>
.banner{
    width: 100%;
    height: 480px;
    background: url(../assets/banner-2.png);
    background-size: 100% 100%;
    font-size: 40px;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
}
.about-box{
    padding: 120px 360px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .us{
        width: 460px;
        height: 346px;
        background: #1C539D;
        padding: 55px 50px;
        p{
            font-size: 18px;
            font-weight: 400;
            color: #FFFFFF;
        }
        div{
            font-size: 24px;
            font-weight: 900;
            color: #FFFFFF;
        }
        .top-1{
            margin-top: 48px;
        }
    }
    .input-box{
        width: 560px;
        height: 456px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        .input-text{
            width: 520px;
            height: 48px;
            padding: 0px 20px;
            outline: none;              
            background: #F5F5F5;    
            border: 0px;       
        }
        .input-message{
            width: 520px;
            padding: 20px;
            background: #F5F5F5;
            outline: none;
            border: 0px;
        }
        .btn{
            width: 560px;
            height: 56px;
            background: #1C539D;
            border-radius: 4px;
            line-height: 56px;
            text-align: center;
            font-size: 18px;
            font-weight: 400;
            color: #FFFFFF;
        }
    }
}
</style>
